import React from "react";
import moment from "moment";
import { CustomFields } from "../../shared/components";
import AnimatedContainer from "../../../../lib/utils/AnimatedContainer";

const Labels = {
  first_name: "First Name",
  last_name: "Last Name",
  email: "email address",
};

export default class AttendeeItem extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      editing: props.editing,
    };
  }

  toggleEditing() {
    this.setState({ editing: !this.state.editing });
  }

  handleChange(value, name) {
    const {
      attendee: { ticket_id },
      changeCustomField,
    } = this.props;

    changeCustomField(ticket_id, value, name);
  }

  handleTextChange(attr, event) {
    const {
      attendee: { ticket_id },
      changeTextField,
    } = this.props;

    changeTextField(ticket_id, event.target.value, attr);
  }

  renderTextField(options) {
    const { fieldName, placeholder, type } = options;
    const { attendee } = this.props;
    let id = `attendees_${this.props.number}_${fieldName}`;
    let name = `attendees[][${fieldName}]`;
    let value = attendee[fieldName];
    let errors, errorMarkup;
    if (attendee.errors) {
      errors = attendee.errors[fieldName];
    }
    if (errors) {
      errorMarkup = errors.map((error, index) => {
        return (
          <div key={index} className="help-block">
            {error}
          </div>
        );
      });
    }

    return (
      <div className={errors ? "form-group has-feeback has-error" : "form-group"}>
        <label className="control-label" htmlFor={id}>
          {Labels[fieldName]}
        </label>
        {this.props.editable ? (
          <React.Fragment>
            <input
              className="form-control"
              id={id}
              value={value}
              onChange={this.handleTextChange.bind(this, fieldName)}
              name={name}
              placeholder={placeholder}
              type={type}
            />
            {errorMarkup}
          </React.Fragment>
        ) : (
          <div className="form-control">{value}</div>
        )}
      </div>
    );
  }

  renderTicketLevel() {
    const { attendee } = this.props;

    return (
      <div>
        <input
          data-testid="t-attende-registr--Attende-attendeesticket_leve"
          name="attendees[][ticket_level][id]"
          type="hidden"
          value={attendee.ticket_level.id}
        />
        <input
          data-testid="t-attende-registr--Attende-attendeesticket_leve"
          name="attendees[][ticket_level][name]"
          type="hidden"
          value={attendee.ticket_level.name}
        />
        <input
          data-testid="t-attende-registr--Attende-attendeesticket_leve"
          name="attendees[][ticket_level][amount]"
          type="hidden"
          value={attendee.ticket_level.amount}
        />
      </div>
    );
  }

  renderCustomFields() {
    const { customFields, attendee, customFieldValues } = this.props;

    return (
      <div>
        {customFields.map((customField, key) => (
          <CustomFields
            key={key}
            customField={customField}
            store={customFieldValues}
            changeHandler={this.handleChange}
            namePrefix="attendees[][custom_fields_hash]"
            editable={this.props.editable}
          />
        ))}
      </div>
    );
  }

  renderEditing() {
    const { attendee } = this.props;

    return (
      <div key="editing" className="items">
        <input
          data-testid="t-attende-registr--Attende-attendeespersisted"
          name="attendees[][persisted]"
          type="hidden"
          value={attendee.persisted}
        />
        <input
          data-testid="t-attende-registr--Attende-attendeesticket_id"
          name="attendees[][ticket_id]"
          type="hidden"
          value={attendee.ticket_id}
        />
        {this.renderTextField({ fieldName: "first_name", type: "text" })}
        {this.renderTextField({ fieldName: "last_name", type: "text" })}
        {this.renderTextField({ fieldName: "email", type: "email" })}
        {this.renderTicketLevel()}
        {this.renderCustomFields()}
      </div>
    );
  }

  renderNotEditing() {
    const { attendee, customFieldValues } = this.props;

    let customData;

    if (customFieldValues) {
      customData = Object.keys(customFieldValues).map((keyName, index) => {
        const name = `attendees[][custom_fields_hash][${keyName}]`;
        let value = customFieldValues[keyName];

        if (!value) {
          return null;
        }
        if (value === "true") {
          value = "Yes";
        }
        if (value === "false") {
          value = "No";
        }
        return (
          <dl key={index} className="clear-m">
            <dt>{keyName}:</dt>
            <dd>{value}</dd>
            <input
              data-testid="t-attende-registr--Attende-hidden"
              type="hidden"
              name={name}
              value={value}
            />
          </dl>
        );
      });
    }

    return (
      <div className="p-sm-a">
        {this.renderHiddenField("persisted")}
        <input
          data-testid="t-attende-registr--Attende-hidden"
          name={"attendees[][ticket_id]"}
          type="hidden"
          value={this.props.attendee.ticket_id}
        />
        {this.renderHiddenField("first_name")}
        {this.renderHiddenField("last_name")}
        {this.renderHiddenField("email")}
        {this.renderTicketLevel()}
        {customData}
      </div>
    );
  }

  renderHiddenField(propName) {
    const name = `attendees[][${propName}]`;
    return (
      <input
        data-testid="t-attende-registr--Attende-hidden"
        name={name}
        type="hidden"
        value={this.props.attendee[propName]}
      />
    );
  }

  header() {
    const iconClasses = `fa fa-stack-1x
      ${this.props.attendee.persisted === "true" ? "fa-check" : "fa-question"}`;

    let baseClass = `fa fa-stack-1x primary-color-text`;

    const openClass = this.state.editing
      ? `${baseClass} fa-minus`
      : `${baseClass} fa-plus`;

    let content;

    if (this.state.editing) {
      content = this.renderEditing();
    } else {
      content = this.renderNotEditing();
    }

    return (
      <div className="attendee-ticket primary-color-background">
        <div className="flex-it space-between align-center">
          <div className="p-sm-a">
            <h3 className="attendee-ticket-header p-sm-r">
              {`${this.props.attendee.first_name} ${this.props.attendee.last_name}`}
            </h3>
            <span className="fa-stack fa">
              <i className="fa fa-circle fa-stack-2x"></i>
              <i className={iconClasses}></i>
            </span>
            <div className="clearfix">
              <hr />
            </div>
            <div>
              <span>{this.props.attendee.ticket_level.name}</span>
            </div>
          </div>
          <div className="p-sm-a">
            <span className="fa-stack fa pointer" onClick={this.toggleEditing.bind(this)}>
              <i className="fa fa-circle fa-stack-2x"></i>
              <i className={openClass}></i>
            </span>
          </div>
        </div>
        {content}
      </div>
    );
  }

  render() {
    return <div className="attendee-container">{this.header()}</div>;
  }
}
